import { breakpointSizes, Size } from "@brightagency/headstart-common";
import throttle from "lodash/throttle";
import { useEffect, useRef, useState } from "react";

export const useBreakpoint = (breakpoint: Size, debounceDelay = 250) => {
    const [isMeetingBreakpoint, setIsMeetingBreakpoint] = useState(
        window.innerWidth >= breakpointSizes[breakpoint],
    );

    const debouncedHandle = useRef(
        throttle(() => {
            if (window.innerWidth >= breakpointSizes[breakpoint]) {
                setIsMeetingBreakpoint(true);
            } else {
                setIsMeetingBreakpoint(false);
            }
        }, debounceDelay),
    ).current;

    useEffect(() => {
        window.addEventListener("resize", debouncedHandle);
        return () => {
            window.removeEventListener("resize", debouncedHandle);
        };
    }, [debouncedHandle]);

    return isMeetingBreakpoint;
};
